<script>
import ActionWithTooltip from "@/components/ActionWithTooltip.vue";
import AudioButton from "@/components/AudioButton.vue";
import TouchOrMouseElement from "@/components/TouchOrMouseElement.vue";
import { MatomoHelper } from "@/helpers";
import { MatomoEventAction, MatomoEventCategory } from "@/types";

export default {
  name: "ArticleContentHeader",
  components: {
    ActionWithTooltip,
    AudioButton,
    TouchOrMouseElement
  },
  props: {
    word: {
      type: Object,
      required: true
    }
  },
  methods: {
    trackPronunciationClick() {
      MatomoHelper.sendEvent(
        MatomoEventCategory.Results,
        MatomoEventAction.ClickPronunciation,
        "Pronunciation on headword"
      );
    }
  }
};
</script>

<template>
  <div class="article-content__header article-header d-flex flex-lg-row justify-content-between">
    <div class="article-header__content">
      <div class="d-inline-block">
        <h5 class="article-header__word">{{ word.lemma }}</h5>
        <sup v-if="word.hnr" class="pol-header-sup">{{ word.hnr }}</sup>
        <sup v-if="word.registeredTrademark" class="pol-header-sup">{{
          word.registeredTrademark
        }}</sup>
      </div>
    </div>
    <div class="article-header__controls">
      <TouchOrMouseElement v-if="word.audioCompactDiscReadOnlyMemory" class="d-inline-flex">
        <template #mouse>
          <ActionWithTooltip hide-on-click class="article-header__btn">
            <template #element>
              <AudioButton
                :audio-url="word.audioCompactDiscReadOnlyMemory"
                :aria-label="$t('article.pronunciation.label')"
                @click="trackPronunciationClick()"
              />
            </template>
            <template #actionInitial>{{ $t("article.pronunciation.label") }}</template>
          </ActionWithTooltip>
        </template>
        <template #touch>
          <AudioButton
            :audio-url="word.audioCompactDiscReadOnlyMemory"
            class="article-header__btn"
            :aria-label="$t('article.pronunciation.label')"
            @click="trackPronunciationClick()"
          />
        </template>
      </TouchOrMouseElement>
    </div>
  </div>
</template>
